module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="popupWrapper">\r\n	<div class="popupClose"><i class="icon icon-i16_x"></i></div>\r\n	<div class="content"></div>\r\n</div>';
}
return __p;
};
